import { type HTTPError } from 'ky'
import { webLogger } from '@muse-web/logger'
import { HttpStatusCode } from '../constants/httpStatusCode'
import { sendLog } from './sendLog'

export const logError = (error: HTTPError) => {
    const { url, method } = error.request

    switch (error.response.status) {
        case HttpStatusCode.CONFLICT:
            webLogger.info(`Conflict request for api. ${url}`)
            break

        case HttpStatusCode.TOO_MANY_REQUESTS:
            webLogger.info(`Too many requests ${url}`)
            break

        case HttpStatusCode.INTERNAL_SERVER_ERROR:
            webLogger.info(`Internal Server error ${url}`)
            break

        case HttpStatusCode.BAD_GATEWAY: {
            const cfRay = error.response.headers.get('cf-ray')
            const requestId = error.response.headers.get('x-request-id')
            const extra = [cfRay && `cf-ray:${cfRay}`, requestId && `request-id:${requestId}`]
                .filter(Boolean)
                .join(' ')
            sendLog(`Bad client gateway error ${method} ${url}${extra ? ` ${extra}` : ''}`)
            break
        }

        default:
            break
    }

    return error
}
